import { Fragment } from 'react'
import { Button, Checkbox, Select, Text, Textarea, Textfield } from '~/shared/ui'
import { ADJUSTMENT_TYPE_GROUPS } from '../../../lib'
import type { AdjustmentFormValues } from '../../../model'

export function AdjustmentFormFields({
  values,
  onChange,
  onDelete,
}: {
  values: AdjustmentFormValues
  onChange: (patch: Partial<AdjustmentFormValues>) => void
  onDelete: () => void
}) {
  return (
    <div className="border-divider flex flex-col gap-3 rounded-lg border px-4 py-3">
      <div className="flex items-center justify-between">
        <Select
          label="Adjustment Type"
          name="adjustmentType"
          value={values.code}
          onValueChange={(value) => onChange({ code: value as string })}
          required
        >
          {ADJUSTMENT_TYPE_GROUPS.map((group, gi) => (
            <Fragment key={group.label}>
              {gi > 0 && <Select.Separator />}
              <Select.Group>
                <Select.Label>{group.label}</Select.Label>
                {group.types.map((type) => (
                  <Select.Item
                    key={type.code}
                    value={type.code}
                  >
                    {type.code} &mdash; {type.label}
                  </Select.Item>
                ))}
              </Select.Group>
            </Fragment>
          ))}
        </Select>
      </div>

      <div className="flex flex-col gap-2">
        <Textfield
          label="Adjustment Amount"
          currency
          value={values.amount ?? undefined}
          onCentsChange={(cents) => onChange({ amount: cents })}
          required
        />

        <Checkbox
          label="Deducted from Total Paid"
          checked={values.deductFromTotalPaid}
          onChange={() => onChange({ deductFromTotalPaid: !values.deductFromTotalPaid })}
          ripple={false}
        />
      </div>

      <Textfield
        label="Tracking Number"
        value={values.trackingNumber}
        onChange={(e) => onChange({ trackingNumber: e.target.value })}
      />

      <div className="flex flex-col gap-1">
        <Text appearance="CAPTION">Comment</Text>
        <Textarea
          value={values.notes}
          onChange={(e) => onChange({ notes: e.target.value })}
          placeholder="Add a comment when additional context is needed"
          rows={3}
        />
      </div>

      <div className="flex justify-end">
        <Button
          size="small"
          materialIcon="delete"
          onClick={onDelete}
        >
          Delete
        </Button>
      </div>
    </div>
  )
}
